// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const VISIBILE_FOR_AUTHENTICATED = "Viditeln\u00e9 jen pro registrovan\u00e9";
export const VISIBILE_FOR_FRIENDS = "Viditeln\u00e9 jen pro p\u0159\u00e1tele";
export const VISIBILE_FOR_PUBLIC = "Viditeln\u00e9 pro v\u0161echny (i Google)";
export const VISIBILE_PRIVATE = "Viditeln\u00e9 jen pro mne";
